var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillHistoryDth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74402 4.2674H8.78402C10.052 4.2674 10.827 4.66289 11.031 5.45776H7.74402V6.14309H11.071C10.971 7.08723 10.123 7.69405 8.54902 7.69405H7.74902V8.54707C9.12702 9.91579 10.183 11.1052 11.332 12.3934H12.721C11.497 10.9966 10.268 9.59688 9.12102 8.48697C10.987 8.43269 12.17 7.54283 12.316 6.16054H13.884V5.46454H12.294C12.2282 4.90853 11.9291 4.40332 11.467 4.06771H13.874V3.38917H7.74402V4.2674Z",
    fill: "#FE6867"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15.5505,
    width: 12,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 16.035,
    width: 11,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6.34123,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 6.82586,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10.025,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 10.5099,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13.7089,
    width: 7,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 14.1934,
    width: 6,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.2952,
    width: 3,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 17.7796,
    width: 2,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8.18337,
    width: 4,
    height: 0.969349,
    rx: 0.484674,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 8.66785,
    width: 3,
    height: 0.0977011,
    stroke: "#39284F",
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.3009,
    width: 15,
    height: 18.4176,
    rx: 1.5,
    stroke: "#39294F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74402 5.78036H13.91",
    stroke: "#FE6867",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74402 3.84166H13.91",
    stroke: "#FE6867",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillHistoryDth);
export default __webpack_public_path__ + "static/media/bill_history_dth.1a059d82ae70a4e521f15c6c6e744e8b.svg";
export { ForwardRef as ReactComponent };